'use client'

import { useContext } from 'react'

import { logWarning } from '@marketplace-web/shared/logging'

import { AbTestsContext } from '../context'

const useAbTest = (name: string) => {
  const { abTests, loggedAbTestsRef } = useContext(AbTestsContext)
  const abTest = abTests[name]

  if (
    Object.entries(abTests).length > 0 &&
    typeof abTest === 'undefined' &&
    !loggedAbTestsRef.current.includes(name)
  ) {
    logWarning('A/B test is not defined. Please check your A/B test configuration.', {
      extra: JSON.stringify({ name }),
    })

    loggedAbTestsRef.current.push(name)
  }

  return abTests[name]
}

export default useAbTest
